module.exports = __webpack_public_path__ + "img/hz.4cf1c87e.png";